import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SummaryBanner = styled(Box)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1.25, 50),
  backgroundColor: theme.palette.info.subtle,
  borderRadius: '4px',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
}));

export const HeaderCellContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  fontWeight: 600,
  fontSize: 12,
  color: '#1E1E1E',
  '.MuiCheckbox-root': {
    padding: theme.spacing(0.5),
  },
}));

export const TableWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(2, 3, 3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  minHeight: 0,
  '.MuiPaper-root': {
    borderRadius: theme.shape.borderRadius,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
  },
}));

export const RootContainer = styled(Box)`
  width: 100%;
  height: calc(100vh - 104px);
`;

export const HeaderStack = styled(Stack)`
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: 10px;
  width: 100%;
  gap: 10px;
`;
